import { Application } from '@hotwired/stimulus'
import * as Sentry from '@sentry/browser'
import Notification from '@stimulus-components/notification'
import RailsNestedForm from '@stimulus-components/rails-nested-form'
import Reveal from '@stimulus-components/reveal'

declare global {
  interface Window {
    Stimulus: Application
  }
}

const application = Application.start()

const previousErrorHandler = application.handleError.bind(application)

// configure Sentry to log errors and prepend the previous handler
const sentryErrorHandler = (error: any, message: any, detail = {}) => {
  previousErrorHandler(error, message, detail)
  Sentry.captureException(error)
}

// overwrite the default handler with our new composed handler
application.handleError = sentryErrorHandler

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// By default, Stimulus catches and logs errors. This avoids an error from one
// Stimulus controller halting JavaScript execution and prevening other
// Stimulus controllers from being executed
// (cf. https://github.com/hotwired/stimulus/issues/236#issuecomment-479694545).
//
// In tests we want to get alerted when JavaScript errors occur, so that
// Cuprite can catch them and re-raise them as Ruby errors which will cause
// the test to fail.
const railsEnv = document.head.querySelector<HTMLMetaElement>('meta[name="rails_env"]')?.content
if (railsEnv === 'test') {
  // propagate errors that happen inside Stimulus controllers
  application.handleError = (error, _message, _detail) => {
    throw error
  }
}

// Register third-party Stimulus controllers
application.register('notification', Notification)
application.register('reveal', Reveal)
application.register('nested-form', RailsNestedForm)

export { application }
